var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pad" },
    [
      _c(
        "el-row",
        { staticClass: "labelDiv", attrs: { gutter: 30 } },
        [
          _c(
            "el-col",
            { staticClass: "inputDiv", attrs: { span: 8 } },
            [
              _c("validation-provider", {
                attrs: { rules: "required|cnpj", name: _vm.nomeAba + "/CNPJ" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var errors = ref.errors
                      return [
                        _c("app-label", {
                          attrs: { label: "CNPJ:", required: true }
                        }),
                        _c("el-input", {
                          directives: [
                            {
                              name: "mask",
                              rawName: "v-mask",
                              value: "##.###.###/####-##",
                              expression: "'##.###.###/####-##'"
                            }
                          ],
                          staticClass: "input",
                          class: { erro: errors.length },
                          attrs: { name: "cnpj" },
                          model: {
                            value: _vm.pessoaJuridica.cnpj,
                            callback: function($$v) {
                              _vm.$set(_vm.pessoaJuridica, "cnpj", $$v)
                            },
                            expression: "pessoaJuridica.cnpj"
                          }
                        }),
                        _c("span", { staticClass: "help erro" }, [
                          _vm._v(_vm._s(errors[0]))
                        ])
                      ]
                    }
                  }
                ])
              })
            ],
            1
          ),
          _c(
            "el-col",
            { staticClass: "inputDiv", attrs: { span: 16 } },
            [
              _c("validation-provider", {
                attrs: {
                  rules: "required",
                  name: _vm.nomeAba + "/Razão social"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var errors = ref.errors
                      return [
                        _c("app-label", {
                          attrs: { label: "Nome/Razão Social", required: true }
                        }),
                        _c("el-input", {
                          staticClass: "input",
                          class: { erro: errors.length },
                          attrs: { name: "razaoSocial", maxlength: "300" },
                          on: {
                            input: function($event) {
                              return _vm.toUppercase($event, "razaoSocial")
                            }
                          },
                          model: {
                            value: _vm.pessoaJuridica.razaoSocial,
                            callback: function($$v) {
                              _vm.$set(_vm.pessoaJuridica, "razaoSocial", $$v)
                            },
                            expression: "pessoaJuridica.razaoSocial"
                          }
                        }),
                        _c("span", { staticClass: "help erro" }, [
                          _vm._v(_vm._s(errors[0]))
                        ])
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-row",
        { staticClass: "labelDiv", attrs: { gutter: 30 } },
        [
          _c(
            "el-col",
            { staticClass: "inputDiv", attrs: { span: 8 } },
            [
              _c("validation-provider", {
                attrs: {
                  rules: "required|cpf",
                  name: _vm.nomeAba + "/CPF do presidente da associação/empresa"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var errors = ref.errors
                      return [
                        _c("app-label", {
                          attrs: {
                            label: "CPF do presidente da associação/empresa:",
                            required: true
                          }
                        }),
                        _c("el-input", {
                          directives: [
                            {
                              name: "mask",
                              rawName: "v-mask",
                              value: "###.###.###-##",
                              expression: "'###.###.###-##'"
                            }
                          ],
                          staticClass: "input",
                          class: { erro: errors.length },
                          attrs: { name: "cpfPresidenteAssociacao" },
                          model: {
                            value: _vm.pessoaJuridica.presidenteAssociacao.cpf,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.pessoaJuridica.presidenteAssociacao,
                                "cpf",
                                $$v
                              )
                            },
                            expression:
                              "pessoaJuridica.presidenteAssociacao.cpf"
                          }
                        }),
                        _c("span", { staticClass: "help erro" }, [
                          _vm._v(_vm._s(errors[0]))
                        ])
                      ]
                    }
                  }
                ])
              })
            ],
            1
          ),
          _c(
            "el-col",
            { staticClass: "inputDiv", attrs: { span: 16 } },
            [
              _c("validation-provider", {
                attrs: {
                  rules: "required",
                  name:
                    _vm.nomeAba + "/Nome do presidente da associação/empresa"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var errors = ref.errors
                      return [
                        _c("app-label", {
                          attrs: {
                            label: "Nome do presidente da associação/empresa",
                            required: true
                          }
                        }),
                        _c("el-input", {
                          staticClass: "input",
                          class: { erro: errors.length },
                          attrs: {
                            name: "nomePresidenteAssociacao",
                            maxlength: "300"
                          },
                          on: {
                            input: function($event) {
                              return _vm.toUppercase(
                                $event,
                                "presidenteAssociacao",
                                "nome"
                              )
                            }
                          },
                          model: {
                            value: _vm.pessoaJuridica.presidenteAssociacao.nome,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.pessoaJuridica.presidenteAssociacao,
                                "nome",
                                $$v
                              )
                            },
                            expression:
                              "pessoaJuridica.presidenteAssociacao.nome"
                          }
                        }),
                        _c("span", { staticClass: "help erro" }, [
                          _vm._v(_vm._s(errors[0]))
                        ])
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-row",
        { staticClass: "labelDiv", attrs: { gutter: 30 } },
        [
          _c(
            "el-col",
            { staticClass: "inputDiv", attrs: { span: 8 } },
            [
              _c("validation-provider", {
                attrs: {
                  name: _vm.nomeAba + "/presidenteAssociacao/Tipo de documento"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var errors = ref.errors
                      return [
                        _c("app-label", {
                          attrs: {
                            label: "Tipo de documento:",
                            required: false
                          }
                        }),
                        _c(
                          "el-select",
                          {
                            staticClass: "input select",
                            class: { erro: errors.length },
                            attrs: {
                              name: "Tipo de documento",
                              "value-key": "codigo",
                              "no-match-text":
                                "Nenhum tipo de documento encontrado",
                              placeholder: "Selecione",
                              clearable: "clearable",
                              filterable: "filterable"
                            },
                            model: {
                              value:
                                _vm.pessoaJuridica.presidenteAssociacao
                                  .tipoDocumento,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.pessoaJuridica.presidenteAssociacao,
                                  "tipoDocumento",
                                  $$v
                                )
                              },
                              expression:
                                "pessoaJuridica.presidenteAssociacao.tipoDocumento"
                            }
                          },
                          _vm._l(_vm.tipoDocumentos, function(item, index) {
                            return _c("el-option", {
                              key: index,
                              attrs: { label: item, value: item }
                            })
                          }),
                          1
                        ),
                        _c("span", { staticClass: "help erro" }, [
                          _vm._v(_vm._s(errors[0]))
                        ])
                      ]
                    }
                  }
                ])
              })
            ],
            1
          ),
          _vm.pessoaJuridica.presidenteAssociacao.tipoDocumento == "OUTROS"
            ? _c(
                "el-col",
                { staticClass: "inputDiv", attrs: { span: 8 } },
                [
                  _c("validation-provider", {
                    attrs: {
                      rules: true,
                      name:
                        _vm.nomeAba +
                        "/presidenteAssociacao/OutrosTipoDocumento"
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(ref) {
                            var errors = ref.errors
                            return [
                              _c("app-label", {
                                attrs: { label: "Outros:", required: true }
                              }),
                              _c("el-input", {
                                staticClass: "input",
                                class: { erro: errors.length },
                                attrs: { name: "Outros", maxlength: "30" },
                                on: {
                                  input: function($event) {
                                    return _vm.toUppercase(
                                      $event,
                                      "presidenteAssociacao",
                                      "outrosTipoDocumento"
                                    )
                                  }
                                },
                                model: {
                                  value:
                                    _vm.pessoaJuridica.presidenteAssociacao
                                      .outrosTipoDocumento,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.pessoaJuridica.presidenteAssociacao,
                                      "outrosTipoDocumento",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "pessoaJuridica.presidenteAssociacao.outrosTipoDocumento"
                                }
                              }),
                              _c("span", { staticClass: "help erro" }, [
                                _vm._v(_vm._s(errors[0]))
                              ])
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      2856943649
                    )
                  })
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _c(
        "el-row",
        { staticClass: "labelDiv", attrs: { gutter: 30 } },
        [
          _c(
            "el-col",
            { staticClass: "inputDiv", attrs: { span: 8 } },
            [
              _c("validation-provider", {
                attrs: { name: _vm.nomeAba + "/presidenteAssociacao/RG" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var errors = ref.errors
                      return [
                        _c("app-label", {
                          attrs: { label: "RG:", required: false }
                        }),
                        _c("el-input", {
                          staticClass: "input",
                          class: { erro: errors.length },
                          attrs: { name: "RG", maxlength: "30" },
                          on: {
                            input: function($event) {
                              return _vm.toUppercase(
                                $event,
                                "presidenteAssociacao",
                                "rg"
                              )
                            }
                          },
                          model: {
                            value: _vm.pessoaJuridica.presidenteAssociacao.rg,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.pessoaJuridica.presidenteAssociacao,
                                "rg",
                                $$v
                              )
                            },
                            expression: "pessoaJuridica.presidenteAssociacao.rg"
                          }
                        }),
                        _c("span", { staticClass: "help erro" }, [
                          _vm._v(_vm._s(errors[0]))
                        ])
                      ]
                    }
                  }
                ])
              })
            ],
            1
          ),
          _c(
            "el-col",
            { staticClass: "inputDiv", attrs: { span: 8 } },
            [
              _c("validation-provider", {
                attrs: {
                  name: _vm.nomeAba + "/presidenteAssociacao/Órgão Expedidor",
                  mode: "lazy"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var errors = ref.errors
                      return [
                        _c("app-label", {
                          attrs: { label: "Órgão expedidor:", required: false }
                        }),
                        _c(
                          "el-select",
                          {
                            staticClass: "input select",
                            class: { erro: errors.length },
                            attrs: {
                              name: "Órgão expedidor",
                              "no-match-text": "Nenhum orgão encontrado",
                              placeholder: "Selecione",
                              "value-key": "id",
                              filterable: "filterable",
                              clearable: "clearable"
                            },
                            model: {
                              value:
                                _vm.pessoaJuridica.presidenteAssociacao
                                  .orgaoExpedidor.nome,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.pessoaJuridica.presidenteAssociacao
                                    .orgaoExpedidor,
                                  "nome",
                                  $$v
                                )
                              },
                              expression:
                                "pessoaJuridica.presidenteAssociacao.orgaoExpedidor.nome"
                            }
                          },
                          _vm._l(_vm.orgaosExpedidores, function(
                            orgaoExpedidor
                          ) {
                            return _c("el-option", {
                              key: orgaoExpedidor.id,
                              attrs: {
                                label: orgaoExpedidor.nome,
                                value: orgaoExpedidor.nome
                              }
                            })
                          }),
                          1
                        ),
                        _c("span", { staticClass: "help erro" }, [
                          _vm._v(_vm._s(errors[0]))
                        ])
                      ]
                    }
                  }
                ])
              })
            ],
            1
          ),
          _c(
            "el-col",
            { staticClass: "inputDiv", attrs: { span: 8 } },
            [
              _c("validation-provider", {
                attrs: {
                  name: _vm.nomeAba + "/presidenteAssociacao/UF do RG",
                  mode: "lazy"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var errors = ref.errors
                      return [
                        _c("app-label", {
                          attrs: { label: "UF do RG:", required: false }
                        }),
                        _c(
                          "el-select",
                          {
                            staticClass: "input select",
                            class: { erro: errors.length },
                            attrs: {
                              name: "UF do RG",
                              "no-match-text": "Nenhuma UF encontrada",
                              placeholder: "Selecione",
                              clearable: "clearable",
                              filterable: "filterable",
                              disabled: !_vm.pessoaJuridica.presidenteAssociacao
                                .orgaoExpedidor.nome
                            },
                            on: { change: _vm.setOrgaoCodigo },
                            model: {
                              value:
                                _vm.pessoaJuridica.presidenteAssociacao
                                  .orgaoExpedidor.estado,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.pessoaJuridica.presidenteAssociacao
                                    .orgaoExpedidor,
                                  "estado",
                                  $$v
                                )
                              },
                              expression:
                                "pessoaJuridica.presidenteAssociacao.orgaoExpedidor.estado"
                            }
                          },
                          _vm._l(_vm.estadosBr, function(estado) {
                            return _c("el-option", {
                              key: estado.codigo,
                              attrs: {
                                label: estado.nome,
                                value: estado.codigo
                              }
                            })
                          }),
                          1
                        ),
                        _c("span", { staticClass: "help erro" }, [
                          _vm._v(_vm._s(errors[0]))
                        ])
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0e76a392", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e76a392","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppPessoaJuridicaProcessoFisico.vue
// module id = null
// module chunks = 